import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  background-color: var(--color-gold-white);
`

export const Main = styled.div`
  ${tw`ta-max-width lg:px-insetX lg:py-insetY grid gap-8 items-start`};

  @media (min-width: 62rem) {
    grid-template-columns: 18rem auto;
  }
`

export const CustomerProfileWrapper = styled.div`
  ${tw`lg:sticky`};
  top: var(--nav-height);
`

export const OrdersAndAddresses = styled.div`
  ${tw`grid`};
`

export const Navigation = styled.div`
  ${tw`flex items-center divide-x divide-gold-white-dark sm:divide-x-0`};
  background-color: var(--color-gold-black);
`

export const NavigationItem = styled.div`
  ${tw`flex items-center justify-between gap-x-4 px-6 sm:px-8 py-4 sm:py-5 w-1/2 sm:w-52 cursor-pointer sm:border-r sm:border-r-gold-white-dark`};
  color: var(--color-gold-white);

  &:hover {
    background-color: var(--color-seal-brown);
  }

  &.active {
    ${tw`bg-seal-brown`};

    svg {
      ${tw`transform rotate-180`};
    }
  }
`

export const Button = styled.button`
  ${tw`flex items-center justify-center w-full h-12 bg-gold-white text-gold-black`};
`
